import { useState } from 'react';
import { useAuth } from '@/context/AuthContext';

export default function Login() {
  const { login, register, loading, error } = useAuth();
  const [mode, setMode] = useState('login'); // 'login' | 'register'
  const [form, setForm] = useState({
    username: '',
    email: '',
    password: '',
    spice_preference: 'sedang',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (mode === 'login') {
      await login(form.email, form.password);
    } else {
      await register(form.username, form.email, form.password, form.spice_preference);
    }
  };

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <div className="app-shell" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <div style={{ background: 'white', border: '2px solid var(--line)', boxShadow: '6px 6px 0 var(--line)', padding: '40px', width: '100%', maxWidth: '420px' }}>
        {/* Brand */}
        <div className="brand" style={{ marginBottom: '32px', justifyContent: 'center' }}>
          <span className="brand-mark">$</span>
          <span>FINANCIAL<br /><b>ROAST</b></span>
        </div>

        <div style={{ display: 'flex', borderBottom: '2px solid var(--line)', marginBottom: '28px' }}>
          <button
            onClick={() => setMode('login')}
            style={{
              flex: 1, padding: '10px', border: 'none', background: mode === 'login' ? 'var(--ink)' : 'transparent',
              color: mode === 'login' ? 'white' : 'var(--muted)', font: "9px 'Press Start 2P'", cursor: 'pointer',
            }}
          >
            MASUK
          </button>
          <button
            onClick={() => setMode('register')}
            style={{
              flex: 1, padding: '10px', border: 'none', background: mode === 'register' ? 'var(--ink)' : 'transparent',
              color: mode === 'register' ? 'white' : 'var(--muted)', font: "9px 'Press Start 2P'", cursor: 'pointer',
            }}
          >
            DAFTAR
          </button>
        </div>

        {error && (
          <div style={{ background: '#fff0ed', border: '1px solid var(--red)', padding: '10px 14px', marginBottom: '20px', color: 'var(--red)', fontSize: '12px', fontWeight: 700 }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {mode === 'register' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label style={{ font: "8px 'Press Start 2P'", color: 'var(--muted)' }}>USERNAME</label>
              <input
                name="username"
                value={form.username}
                onChange={handleChange}
                required
                placeholder="nama_kamu"
                style={{ border: '2px solid var(--line)', padding: '10px 12px', font: '14px inherit', outline: 'none', width: '100%' }}
              />
            </div>
          )}

          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label style={{ font: "8px 'Press Start 2P'", color: 'var(--muted)' }}>EMAIL</label>
            <input
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              required
              placeholder="kamu@email.com"
              style={{ border: '2px solid var(--line)', padding: '10px 12px', font: '14px inherit', outline: 'none', width: '100%' }}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label style={{ font: "8px 'Press Start 2P'", color: 'var(--muted)' }}>PASSWORD</label>
            <input
              name="password"
              type="password"
              value={form.password}
              onChange={handleChange}
              required
              placeholder="••••••••"
              style={{ border: '2px solid var(--line)', padding: '10px 12px', font: '14px inherit', outline: 'none', width: '100%' }}
            />
          </div>

          {mode === 'register' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label style={{ font: "8px 'Press Start 2P'", color: 'var(--muted)' }}>TINGKAT PEDAS ROAST</label>
              <select
                name="spice_preference"
                value={form.spice_preference}
                onChange={handleChange}
                style={{ border: '2px solid var(--line)', padding: '10px 12px', font: '14px inherit', outline: 'none', width: '100%', background: 'white' }}
              >
                <option value="mild">🟢 Mild — Santai aja</option>
                <option value="sedang">🟡 Sedang — Lumayan pedes</option>
                <option value="pedas">🔴 Pedas — Siap digituin</option>
              </select>
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="primary-button"
            style={{ width: '100%', justifyContent: 'center', marginTop: '8px', background: 'var(--ink)', color: 'white', border: '2px solid var(--line)' }}
          >
            {loading ? 'LOADING...' : mode === 'login' ? 'MASUK' : 'DAFTAR SEKARANG'}
          </button>
        </form>
      </div>
    </div>
  );
}
